<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-card>
    <el-row>
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/Refund/myApproveList' }">退款系统</el-breadcrumb-item>
          <el-breadcrumb-item>发起退款</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <!-- RefundSystem card header area -->

    <!-- RefundSystem card content area -->
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="未消费退款" name="first">
        <div class="content_box">
          <div class="steps">
            <el-steps align-center :active="1">
              <el-step title="发起审批"></el-step>
              <el-step title="一级主管审批"></el-step>
              <el-step title="二级主管审批"></el-step>
              <el-step title="市场审批"></el-step>
              <el-step title="财务审批"></el-step>
            </el-steps>
          </div>
          <div class="feund_form">
            <div class="title_1">{{ title_1 }}</div>
            <el-form
              ref="a_form.Informations"
              :model="a_form.Informations"
              label-position="left"
              label-width="100px"
              :rules="a_rules"
            >
              <el-row :gutter="40">
                <el-col :span="11">
                  <el-form-item label="订单号" prop="OrderNo">
                    <el-input v-model="a_form.Informations.OrderNo" placeholder="如无订单号客户可以填写未录入盘古"></el-input>
                  </el-form-item>
                  <el-form-item label="公司名称" prop="ComanyName">
                    <el-input
                      v-model="a_form.Informations.ComanyName"
                      placeholder="请填写公司名称"
                      @blur="blurComanyNameAForm"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="客户联系人" prop="LinkName">
                    <el-input
                      v-model="a_form.Informations.LinkName"
                      placeholder="请填写客户联系人"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话" prop="LinkPhone">
                    <el-input
                      v-model="a_form.Informations.LinkPhone"
                      placeholder="请填写联系电话"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="是否开发票" prop="IsOpenTicket">
                    <el-select
                      style="width: 100%;"
                      v-model="a_form.Informations.IsOpenTicket"
                      placeholder="请选择是否开发票"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="是否开户" prop="IsOpen">
                    <el-select
                      style="width: 100%;"
                      disabled
                      v-model="a_form.Informations.IsOpen"
                      placeholder="请选择是否开户"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="申请部门" prop="MainName">
                    <el-input
                      disabled
                      v-model="a_form.Informations.MainName"
                      placeholder="请填写申请部门"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="申请人" prop="TrueName">
                    <el-input
                      disabled
                      v-model="a_form.Informations.TrueName"
                      placeholder="请填写申请人"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="退款产品" prop="Product" required>
                    <el-select
                      style="width: 100%;"
                      v-model="a_form.Informations.Product"
                      placeholder="请选择退款产品"
                    >
                      <el-option label="信息流" value="0"></el-option>
                      <el-option label="大搜" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="退款方式" prop="RefundStyle">
                    <el-input
                      disabled
                      placeholder="退现"
                      v-model="a_form.Informations.RefundStyle"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="是否签合同" prop="IsAgreement" required>
                    <el-select
                      style="width: 100%;"
                      v-model="a_form.Informations.IsAgreement"
                      placeholder="请选择是否签合同"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="是否撤单完成" prop="IsBack">
                    <el-select
                      style="width: 100%;"
                      v-model="a_form.Informations.IsBack"
                      placeholder="请选择是撤单完成"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 是否有合同 行 -->
              <el-row :gutter="40">
                <el-col :span="11">
                  <el-form-item label="是否有合同" prop="IsHaveAgreement">
                    <el-select
                      style="width:100%;float:left;"
                      v-model="a_form.Informations.IsHaveAgreement"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="11"
                  v-if="a_form.Informations.IsHaveAgreement == 0 ? true : false"
                >
                  <el-form-item
                    label="原因"
                    prop="BecauseOfA"
                    label-width="100px"
                  >
                    <el-input
                      v-model="a_form.Informations.BecauseOfA"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 是否有收据 行 -->
              <el-row :gutter="40">
                <el-col :span="11">
                  <el-form-item label="是否有收据" prop="IsHaveReceipt">
                    <el-select
                      style="width:100%;float:left;"
                      v-model="a_form.Informations.IsHaveReceipt"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="11"
                  v-if="a_form.Informations.IsHaveReceipt == 0 ? true : false"
                >
                  <el-form-item
                    label="原因"
                    prop="BecauseOfR"
                    label-width="100px"
                  >
                    <el-input
                      v-model="a_form.Informations.BecauseOfR"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 是否有发票 行 -->
              <el-row :gutter="40">
                <el-col :span="11">
                  <el-form-item label="是否有发票" prop="IsHaveTicket">
                    <el-select
                      style="width:100%;float:left;"
                      v-model="a_form.Informations.IsHaveTicket"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="11"
                  v-if="a_form.Informations.IsHaveTicket == 0 ? true : false"
                >
                  <el-form-item
                    label="原因"
                    prop="BecauseOfT"
                    label-width="100px"
                  >
                    <el-input
                      v-model="a_form.Informations.BecauseOfT"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 退款金额 行 -->
              <el-row :gutter="40">
                <el-col :span="11">
                  <el-form-item label="退款金额" prop="RefundMoney">
                    <el-input
                      type="number"
                      v-model="a_form.Informations.RefundMoney"
                      placeholder="请填写退款金额"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
									<!-- 锚点 -->
                  <el-form-item label="退款原因" prop="RefundBecause">
										<el-cascader style="width: 100%;" v-model="becauseArray" :options="options"
										 :props="{ expandTrigger: 'hover' }" @change="handleBeacuseOfAChange"></el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 退款原因详情 行 -->
              <el-row :gutter="40">
                <el-col :span="22">
                  <el-form-item label="退款原因详情" v-if="RefundBecauseOf_flag_a">
                    <el-input
                      type="textarea"
                      v-model="a_form.Informations.RefundBecauseOf"
                      placeholder="请填写退款原因详情"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 分割线 -->
              <el-divider></el-divider>
              <div class="title_1">所需退款资料</div>
              <el-row :gutter="40">
                <el-col :span="11">
                  <!-- 退款确认书 -->
                  <el-form-item label="退款确认书" label-width="120px" required>
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_RefundConfirmation"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
                      <el-button style="margin-left: 10px;" size="small" type="success" @click="download_doc('RefundConfirmation')" >下载模板</el-button>
                      <div slot="tip" class="el-upload__tip">
                        需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 委托授权书 -->
                  <el-form-item label="委托授权书" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_Entrust"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <el-button
                        style="margin-left: 10px;"
                        size="small"
                        type="success"
                        @click="download_doc('Entrust')"
                        >下载模板</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 主体资质复印件 -->
                  <el-form-item label="主体资质复印件" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_Qualifications"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 法人身份复印件 -->
                  <el-form-item label="法人身份复印件" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_LegalCard"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <!-- 发票 -->
                  <el-form-item label="发票" label-width="60px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_Ticket"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <el-button
                        style="margin-left: 10px;"
                        size="small"
                        type="success"
                        @click="download_doc('Ticket')"
                        >下载模板</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        如已开需提供，如遗失需提供遗失声明
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 合同 -->
                  <el-form-item label="合同" label-width="60px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_Agreement"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <el-button
                        style="margin-left: 10px;"
                        size="small"
                        type="success"
                        @click="download_doc('Agreement')"
                        >下载模板</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        如已开需提供，如遗失需提供遗失声明
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 收据 -->
                  <el-form-item label="收据" label-width="60px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_Receipt"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <el-button
                        style="margin-left: 10px;"
                        size="small"
                        type="success"
                        @click="download_doc('Receipt')"
                        >下载模板</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        如已开需提供，如遗失需提供遗失声明
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 被委托人身份证复印件 -->
                  <el-form-item label="被委托人身份证复印件" label-width="90px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_EntrustCard"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        如已开需提供，如遗失需提供遗失声明
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 分割线 -->
              <el-divider></el-divider>
              <el-form-item style="float:right;margin-bottom:40px;">
                <el-button :disabled=aDisabled type="primary" @click="a_form_submitForm(a_form)"
                  >提交未消费退款申请</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已消费退现" name="second">
        <div class="content_box">
          <div class="steps">
            <el-steps align-center :active="1">
              <el-step title="发起申请"></el-step>
              <el-step title="一级主管审批"></el-step>
              <el-step title="销售经理审批"></el-step>
              <el-step title="二级主管审批"></el-step>
              <el-step title="运营总监审批"></el-step>
              <el-step title="财务审批"></el-step>
            </el-steps>
          </div>
          <div class="feund_form">
            <div class="title_1">已消费退现申请核查表</div>
            <el-form
              ref="b_form.Informations"
              :model="b_form.Informations"
              label-position="left"
              label-width="100px"
              :rules="b_rules"
            >
              <el-row :gutter="40">
                <el-col :span="11">
                  <el-form-item label="用户名" prop="AccountName" required>
                    <el-input
                      v-model="b_form.Informations.AccountName"
                      placeholder="请填写用户名"
                      @blur="blurAccountNameBForm"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="公司名称" prop="ComanyName">
                    <el-input
                      v-model="b_form.Informations.ComanyName"
                      placeholder="请填写公司名称"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="客户联系人" prop="LinkName">
                    <el-input
                      v-model="b_form.Informations.LinkName"
                      placeholder="请填写客户联系人"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话" prop="LinkPhone">
                    <el-input
                      v-model="b_form.Informations.LinkPhone"
                      placeholder="请填写联系电话"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="发票是否遗失" prop="IsLoseTicket">
                    <el-select
                      style="width: 100%;"
                      v-model="b_form.Informations.IsLoseTicket"
                      placeholder="请选择发票是否遗失"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="已消费金额" prop="ConsumeMoney">
                    <el-input
                      disabled
                      v-model="b_form.Informations.ConsumeMoney"
                      placeholder="已消费金额"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="核查申请部门" prop="MainName">
                    <el-input
                      v-model="b_form.Informations.MainName"
                      disabled
                      placeholder="请填写申请部门"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="核查申请人" prop="TrueName">
                    <el-input
                      v-model="b_form.Informations.TrueName"
                      disabled
                      placeholder="请填写申请人"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="退款产品" prop="Product" required>
                    <el-select
                      style="width: 100%;"
                      v-model="b_form.Informations.Product"
                      @change="changeSelectB"
                      placeholder="请选择退款产品"
                    >
                      <el-option label="信息流" value="0"></el-option>
                      <el-option label="大搜" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="退款方式" prop="RefundStyle">
                    <el-input
                      disabled
                      placeholder="退现"
                      v-model="b_form.Informations.RefundStyle"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="预存款是否消费完毕"
                    prop="IsDeposit"
                    required
                  >
                    <el-select
                      style="width: 100%;"
                      v-model="b_form.Informations.IsDeposit"
                      disabled
                      placeholder="请选择预存款是否消费完毕"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 退款金额 行 -->
              <el-row :gutter="40">
                <el-col :span="11">
                  <el-form-item label="退款金额" prop="RefundMoney">
                    <el-input
                      type="number"
                      v-model="b_form.Informations.RefundMoney"
											@blur="b_blur_deduction()"
                      placeholder="请填写退款金额"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="退款原因" prop="RefundBecause">
                    <el-cascader style="width: 100%;" v-model="becauseArray" :options="options"
                     :props="{ expandTrigger: 'hover' }" @change="handleBeacuseOfBChange"></el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 退款原因详情 行 -->
              <el-row :gutter="40">
                <el-col :span="22">
                  <el-form-item label="退款原因详情" prop="RefundBecauseOf" v-if="RefundBecauseOf_flag_b">
                    <el-input
                      type="textarea"
                      v-model="b_form.Informations.RefundBecauseOf"
                      placeholder="请填写退款原因详情"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
							<!-- 已消费退现销售扣减信息 -->
							<el-row :gutter="40">
							  <el-col :span="22">
							    <el-form-item label="销售扣减信息" v-if="b_sellDeductionFlag">
							      <el-input type="textarea" v-model="b_sellDeduction" :disabled="true"></el-input>
							    </el-form-item>
							  </el-col>
							</el-row>
							<!-- 已消费退现客服扣减信息 -->
							<el-row :gutter="40">
							  <el-col :span="22">
							    <el-form-item label="客服扣减信息" v-if="b_serviceDeductionFlag">
							      <el-input type="textarea" v-model="b_serviceDeduction" :disabled="true"></el-input>
							    </el-form-item>
							  </el-col>
							</el-row>
              <!-- 分割线 -->
              <el-divider></el-divider>
              <div class="title_1">所需退款资料</div>
              <el-row :gutter="40">
                <el-col :span="11">
                  <!-- 退款确认书 -->
                  <el-form-item label="退款确认书" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_RefundConfirmation"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <el-button
                        style="margin-left: 10px;"
                        size="small"
                        type="success"
                        @click="download_doc('RefundConfirmation')"
                        >下载模板</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 主体资质复印件 -->
                  <el-form-item label="主体资质复印件" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_Qualifications"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 法人身份复印件 -->
                  <el-form-item label="法人身份复印件" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_LegalCard"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <!-- 委托授权书 -->
                  <el-form-item label="委托授权书" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_Entrust"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <el-button
                        style="margin-left: 10px;"
                        size="small"
                        type="success"
                        @click="download_doc('Entrust')"
                        >下载模板</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        如已开需提供，如遗失需提供遗失声明
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 发票遗失声明 -->
                  <el-form-item label="发票遗失声明" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_TicketLose"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <el-button
                        style="margin-left: 10px;"
                        size="small"
                        type="success"
                        @click="download_doc('TicketLose')"
                        >下载模板</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        如已开需提供，如遗失需提供遗失声明
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 被委托人身份证复印件 -->
                  <el-form-item
                    label="被委托人身份证复印件"
                    label-width="120px"
                  >
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_EntrustCard"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        退款账户非对公账户需提供，需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 分割线 -->
              <el-divider></el-divider>
              <el-form-item style="float:right;margin-bottom:40px;">
                <el-button type="primary" @click="b_form_submitForm(b_form)"
                  >提交已消费退现申请</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已消费转账户" name="third">
        <div class="content_box">
          <div class="steps">
            <el-steps align-center :active="1">
              <el-step title="发起申请"></el-step>
              <el-step title="一级主管"></el-step>
              <el-step title="二级主管"></el-step>
              <el-step title="财务审批"></el-step>
            </el-steps>
          </div>
          <div class="feund_form">
            <div class="title_1">已消费转账户申请核查表</div>
            <el-form
              ref="c_form.Informations"
              :model="c_form.Informations"
              label-position="left"
              label-width="100px"
              :rules="c_rules"
            >
              <el-row :gutter="40">
                <el-col :span="11">
                  <el-form-item label="用户名" prop="AccountName" required>
                    <el-input
                      v-model="c_form.Informations.AccountName"
                      placeholder="请填写用户名"
                      @blur="blurAccountNameCForm"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="公司名称" prop="ComanyName">
                    <el-input
                      v-model="c_form.Informations.ComanyName"
                      placeholder="请填写公司名称"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="客户联系人" prop="LinkName">
                    <el-input
                      v-model="c_form.Informations.LinkName"
                      placeholder="请填写客户联系人"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话" prop="LinkPhone">
                    <el-input
                      v-model="c_form.Informations.LinkPhone"
                      placeholder="请填写联系电话"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="发票是否遗失" prop="IsLoseTicket">
                    <el-select
                      style="width: 100%;"
                      v-model="c_form.Informations.IsLoseTicket"
                      placeholder="请选择发票是否遗失"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="已消费金额" prop="ConsumeMoney">
                    <el-input
                      disabled
                      v-model="c_form.Informations.ConsumeMoney"
                      placeholder="已消费金额"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="核查申请部门" prop="MainName">
                    <el-input
                      v-model="c_form.Informations.MainName"
                      disabled
                      placeholder="请填写申请部门"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="核查申请人" prop="TrueName">
                    <el-input
                      v-model="c_form.Informations.TrueName"
                      disabled
                      placeholder="请填写申请人"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="退款产品" prop="Product" required>
                    <el-select
                      style="width: 100%;"
                      v-model="c_form.Informations.Product"
                      @change="changeSelectC"
                      placeholder="请选择退款产品"
                    >
                      <el-option label="信息流" value="0"></el-option>
                      <el-option label="大搜" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="退款方式" prop="RefundStyle">
                    <el-input
                      disabled
                      placeholder="退现"
                      v-model="c_form.Informations.RefundStyle"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="预存款是否消费完毕"
                    prop="IsDeposit"
                    required
                  >
                    <el-select
                      style="width: 100%;"
                      v-model="c_form.Informations.IsDeposit"
                      disabled
                      placeholder="请选择预存款是否消费完毕"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 退款金额 行 -->
              <el-row :gutter="40">
                <el-col :span="11">
                  <el-form-item label="退款金额" prop="RefundMoney">
                    <el-input type="number" v-model="c_form.Informations.RefundMoney" placeholder="请填写退款金额" @blur="c_blur_deduction()"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="退款原因" prop="RefundBecause">
                    <el-cascader style="width: 100%;" v-model="becauseArray" :options="options"
                     :props="{ expandTrigger: 'hover' }" @change="handleBeacuseOfCChange"></el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 退款原因详情 行 -->
              <el-row :gutter="40">
                <el-col :span="22">
                  <el-form-item label="退款原因详情" prop="RefundBecauseOf" v-if="RefundBecauseOf_flag_c">
                    <el-input
                      type="textarea"
                      v-model="c_form.Informations.RefundBecauseOf"
                      placeholder="请填写退款原因详情"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
							<!-- 已消费转账户销售扣减信息 -->
							<el-row :gutter="40">
							  <el-col :span="22">
							    <el-form-item label="销售扣减信息" v-if="c_sellDeductionFlag">
							      <el-input type="textarea" v-model="c_sellDeduction" :disabled="true"></el-input>
							    </el-form-item>
							  </el-col>
							</el-row>
							<!-- 已消费转账户客服扣减信息 -->
							<el-row :gutter="40">
							  <el-col :span="22">
							    <el-form-item label="客服扣减信息" v-if="c_serviceDeductionFlag">
							      <el-input type="textarea" v-model="c_serviceDeduction" :disabled="true"></el-input>
							    </el-form-item>
							  </el-col>
							</el-row>
              <!-- 分割线 -->
              <el-divider></el-divider>
              <div class="title_1">所需退款资料</div>
              <el-row :gutter="40">
                <el-col :span="11">
                  <!-- 转账户确认书 -->
                  <el-form-item label="转账户确认书" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_Transfers"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <el-button
                        style="margin-left: 10px;"
                        size="small"
                        type="success"
                        @click="download_doc('Transfers')"
                        >下载模板</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 客户资质 -->
                  <el-form-item label="客户资质" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_Customer"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 发票遗失证明 -->
                  <el-form-item label="发票遗失证明" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_TicketLose"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <el-button
                        style="margin-left: 10px;"
                        size="small"
                        type="success"
                        @click="download_doc('TicketLose')"
                        >下载模板</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 两个账户后台截图 -->
                  <el-form-item label="两个账户后台截图" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_AccountPic"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <!-- 委托授权书 -->
                  <el-form-item label="委托授权书" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_Entrust"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <el-button
                        style="margin-left: 10px;"
                        size="small"
                        type="success"
                        @click="download_doc('Entrust')"
                        >下载模板</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        如已开需提供，如遗失需提供遗失声明
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 两个账户营业执照的复印件 -->
                  <el-form-item
                    label="两个账户营业执照的复印件"
                    label-width="120px"
                  >
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_License"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        如已开需提供，如遗失需提供遗失声明
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 被委托人身份证复印件 -->
                  <el-form-item
                    label="被委托人身份证复印件"
                    label-width="120px"
                  >
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_EntrustCard"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        退款账户非对公账户需提供，需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 分割线 -->
              <el-divider></el-divider>
              <el-form-item style="float:right;margin-bottom:40px;">
                <el-button type="primary" @click="c_form_submitForm(c_form)"
                  >提交已消费转账户申请</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="保证金" name="fourth">
        <div class="content_box">
          <div class="steps">
            <el-steps align-center :active="1">
              <el-step title="发起申请"></el-step>
              <el-step title="一级主管审核"></el-step>
              <el-step title="二级主管审核"></el-step>
              <el-step title="质检审核"></el-step>
              <el-step title="运营总监审批"></el-step>
              <el-step title="财务审核"></el-step>
            </el-steps>
          </div>
          <div class="feund_form">
            <div class="title_1">保证金申请核查表</div>
            <el-form
              ref="d_form.Informations"
              :model="d_form.Informations"
              label-position="left"
              label-width="100px"
              :rules="d_rules"
            >
              <el-row :gutter="40">
                <el-col :span="11">
                  <el-form-item label="用户名" prop="AccountName" required>
                    <el-input
                      v-model="d_form.Informations.AccountName"
                      placeholder="请填写用户名"
                      @blur="blurAccountNameDForm"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="公司名称" prop="ComanyName">
                    <el-input
                      v-model="d_form.Informations.ComanyName"
                      placeholder="请填写公司名称"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="客户联系人" prop="LinkName">
                    <el-input
                      v-model="d_form.Informations.LinkName"
                      placeholder="请填写客户联系人"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话" prop="LinkPhone">
                    <el-input
                      v-model="d_form.Informations.LinkPhone"
                      placeholder="请填写联系电话"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="发票是否遗失" prop="IsLoseTicket">
                    <el-select
                      style="width: 100%;"
                      v-model="d_form.Informations.IsLoseTicket"
                      placeholder="请选择发票是否遗失"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="已消费金额" prop="ConsumeMoney">
                    <el-input
                      disabled
                      v-model="d_form.Informations.ConsumeMoney"
                      placeholder="已消费金额"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="核查申请部门" prop="MainName">
                    <el-input
                      v-model="d_form.Informations.MainName"
                      disabled
                      placeholder="请填写申请部门"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="核查申请人" prop="TrueName">
                    <el-input
                      v-model="d_form.Informations.TrueName"
                      disabled
                      placeholder="请填写申请人"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="退款产品" prop="Product" required>
                    <el-select
                      style="width: 100%;"
                      v-model="d_form.Informations.Product"
                      @change="changeSelectD"
                      placeholder="请选择退款产品"
                    >
                      <el-option label="信息流" value="0"></el-option>
                      <el-option label="大搜" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="退款方式" prop="RefundStyle">
                    <el-input
                      disabled
                      placeholder="退现"
                      v-model="d_form.Informations.RefundStyle"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="预存款是否消费完毕"
                    prop="IsDeposit"
                    required
                  >
                    <el-select
                      style="width: 100%;"
                      v-model="d_form.Informations.IsDeposit"
                      disabled
                      placeholder="请选择预存款是否消费完毕"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 退款金额 行 -->
              <el-row :gutter="40">
                <el-col :span="11">
                  <el-form-item label="退款金额" prop="RefundMoney">
                    <el-input
                      type="number"
                      v-model="d_form.Informations.RefundMoney"
                      placeholder="请填写退款金额"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="退款原因" prop="RefundBecause">
                    <el-cascader style="width: 100%;" v-model="becauseArray" :options="options"
                     :props="{ expandTrigger: 'hover' }" @change="handleBeacuseOfDChange"></el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 退款原因详情 行 -->
              <el-row :gutter="40">
                <el-col :span="22">
                  <el-form-item label="退款原因详情" prop="RefundBecauseOf" v-if="RefundBecauseOf_flag_d">
                    <el-input
                      type="textarea"
                      v-model="d_form.Informations.RefundBecauseOf"
                      placeholder="请填写退款原因详情"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 分割线 -->
              <el-divider></el-divider>
              <div class="title_1">所需退款资料</div>
              <el-row :gutter="40">
                <el-col :span="11">
                  <!-- 退款确认书 -->
                  <el-form-item label="退款确认书" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_RefundConfirmation"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <el-button
                        style="margin-left: 10px;"
                        size="small"
                        type="success"
                        @click="download_doc('RefundConfirmation')"
                        >下载模板</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 主体资质复印件 -->
                  <el-form-item label="主体资质复印件" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_Qualifications"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 委托授权书 -->
                  <el-form-item label="委托授权书" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_Entrust"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <el-button
                        style="margin-left: 10px;"
                        size="small"
                        type="success"
                        @click="download_doc('Entrust')"
                        >下载模板</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        需加盖红色公章
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <!-- 法人身份证复印件 -->
                  <el-form-item label="法人身份证复印件" label-width="120px">
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_LegalCard"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        如已开需提供，如遗失需提供遗失声明
                      </div>
                    </el-upload>
                  </el-form-item>
                  <!-- 被委托人身份证复印件 -->
                  <el-form-item
                    label="被委托人身份证复印件"
                    label-width="120px"
                  >
                    <el-upload
                      style="float:left;"
                      class="upload-demo"
                      action="http://tuikuan.text.ruizhiqi.com/publicApi/Informations/UploadFile"
                      :on-success="handleSuccess_EntrustCard"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        如已开需提供，如遗失需提供遗失声明
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 分割线 -->
              <el-divider></el-divider>
              <el-form-item style="float:right;margin-bottom:40px;">
                <el-button type="primary" @click="d_form_submitForm(d_form)"
                  >提交保证金申请</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    </el-card>
  </div>
</template>
<script>
import {
  InformationsAdd,
  MaterialAdd,
  GetFlowSendNextSteps,
  Excuteflow,
  GetIsOpen,
  GetRefund,
  GetBalanceMoney,
  GetIsOk,
	Getkoujian
} from "../../until/ZeusApiSDK/Logic/RefundLogic";
import { cryptoDecode } from "../../until/encrypt.js"
export default {
  data() {
    return {
      userInfo: {},
      tabIndex: 0,
      activeName: "first",
      title_1: "未消费退款申请核查表",
			becauseArray : [],
			RefundBecauseOf_flag_a : false,
			RefundBecauseOf_flag_b : false,
			RefundBecauseOf_flag_c : false,
			RefundBecauseOf_flag_d : false,
			
			b_sellDeductionFlag : false,
			b_serviceDeductionFlag : false,
			b_sellDeduction : '',
			b_serviceDeduction : '',
			c_sellDeductionFlag : false,
			c_serviceDeductionFlag : false,
			c_sellDeduction : '',
			c_serviceDeduction : '',
			/**
			 * 锚点
			 */
			options:[
				{
					value: '客户原因',
					label: '客户原因',
					children: [
						{
							value: '推广效果不满意',
							label: '推广效果不满意',
						},
						{
							value: '对产品不认可',
							label: '对产品不认可',
						},
						{
							value: '业务变更',
							label: '业务变更',
						},
						{
							value: '公司倒闭',
							label: '公司倒闭',
						},
						{
							value: '合伙人分歧',
							label: '合伙人分歧',
						},
						{
							value: '保证金',
							label: '保证金',
						},
						{
							value: '打错款',
							label: '打错款',
						},
						{
							value: '资金紧缺',
							label: '资金紧缺',
						},
					]
				},
				{
					value: '政策原因',
					label: '政策原因',
					children: [
						{
							value: '涉嫌违规',
							label: '涉嫌违规',
						},
						{
							value: '行业禁推',
							label: '行业禁推',
						},
						{
							value: '违规跨区',
							label: '违规跨区',
						},
						{
							value: '自查下线',
							label: '自查下线',
						},
						{
							value: '老户暂停',
							label: '老户暂停',
						}
					]
				},
				{
					value: '资质原因',
					label: '资质原因',
					children: [
						{
							value: '资质到期',
							label: '资质到期',
						},
						{
							value: '缺少资质',
							label: '缺少资质',
						},
						{
							value: '资质拉黑',
							label: '资质拉黑',
						},
						{
							value: '无商标',
							label: '无商标',
						}
					]
				},
				{
					value: '网站原因',
					label: '网站原因',
					children: [
						{
							value: '网站制作不满意',
							label: '网站制作不满意',
						},
						{
							value: '网站备案不通过',
							label: '网站备案不通过',
						},
						{
							value: '网站备案时间长',
							label: '网站备案时间长',
						},
						{
							value: '网站域名到期',
							label: '网站域名到期',
						},
						{
							value: '小程序审核不通过',
							label: '小程序审核不通过',
						}
					]
				},
				{
					value: '财务原因',
					label: '财务原因',
					children: [
						{
							value: '对公账户',
							label: '对公账户',
						},
						{
							value: '还加款',
							label: '还加款',
						}
					]
				},
				{
					value: '产品原因',
					label: '产品原因',
					children: [
						{
							value: '产品下线',
							label: '产品下线',
						}
					]
				},
				{
					value: '其他原因',
					label: '其他原因',
				},
			],
      a_form: {
        Informations: {
          OrderNo : '',
          ComanyName : '',
          LinkName : '',
          LinkPhone : '',
          IsOpenTicket : '',
          IsOpen : '',
          TrueName :'',
          MainName :'',
          Product :'0',
          RefundStyle :'',
          IsAgreement :'',
          IsBack :'',
          IsHaveAgreement :'',
          BecauseOfA :'',
          IsHaveReceipt :'',
          BecauseOfR :'',
          IsHaveTicket :'',
          BecauseOfT :'',
          RefundMoney :'',
          RefundBecause :'',
          RefundBecauseOf :'',
        },
        Material: {}
      },
      b_form: {
        Informations: {
          AccountName : '',
          ComanyName : '',
          LinkName : '',
          LinkPhone : '',
          IsLoseTicket : '',
          ConsumeMoney : '',
          MainName : '',
          TrueName : '',
          Product : '0',
          RefundStyle : '',
          IsDeposit : '',
          RefundMoney : '',
          RefundBecause : '',
          RefundBecauseOf : '',
        },
        Material: {}
      },
      c_form: {
        Informations: {
          AccountName : '',
          ComanyName : '',
          LinkName : '',
          LinkPhone : '',
          IsLoseTicket : '',
          ConsumeMoney : '',
          MainName : '',
          TrueName : '',
          Product : '0',
          RefundStyle : '',
          IsDeposit : '',
          RefundMoney : '',
          RefundBecause : '',
          RefundBecauseOf : '',
        },
        Material: {}
      },
      d_form: {
        Informations: {
          AccountName : '',
          ComanyName : '',
          LinkName : '',
          LinkPhone : '',
          IsLoseTicket : '',
          ConsumeMoney : '',
          MainName : '',
          TrueName : '',
          Product : '0',
          RefundStyle : '',
          IsDeposit : '',
          RefundMoney : '',
          RefundBecause : '',
          RefundBecauseOf : '',
        },
        Material: {}
      },
      a_rules: {
        OrderNo: [
          { required: true, message: "请填写订单号", trigger: "blur" }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        ComanyName: [
          { required: true, message: "请填写公司名称", trigger: "blur" }
        ],
        LinkName: [
          { required: true, message: "请填写客户联系人", trigger: "blur" }
        ],
        LinkPhone: [
          {
            required: true,
            pattern: /^1[34578]\d{9}$/, //可以写正则表达式呦呦呦
            message: "目前只支持中国大陆的手机号码",
            trigger: "blur"
          }
        ],
        Product: [
          { required: true, message: "请选择退款产品", trigger: "change" }
        ],
        IsOpenTicket: [
          { required: true, message: "请选择是否开发票", trigger: "change" }
        ],
        IsAgreement: [
          { required: true, message: "请选择是否签合同", trigger: "change" }
        ],
        IsBack: [
          { required: true, message: "请选择是否撤单完成", trigger: "change" }
        ],
        IsHaveAgreement: [
          { required: true, message: "请选择是否有合同", trigger: "change" }
        ],
        IsHaveReceipt: [
          { required: true, message: "请选择是否有收据", trigger: "change" }
        ],
        IsHaveTicket: [
          { required: true, message: "请选择是否有发票", trigger: "change" }
        ],
        RefundMoney: [
          { required: true, message: "请填写退款金额", trigger: "blur" }
        ],
        RefundBecause: [
          { required: true, message: "请选择退款原因", trigger: "change" }
        ],
        RefundBecauseOf: [
          { required: true, message: "请填写退款原因详情", trigger: "blur" }
        ],
        BecauseOfA: [
          { required: true, message: "请填写没有合同的原因", trigger: "blur" }
        ],
        BecauseOfR: [
          { required: true, message: "请填写没有收据的原因", trigger: "blur" }
        ],
        BecauseOfT: [
          { required: true, message: "请填写没有发票的原因", trigger: "blur" }
        ]
      },
      b_rules: {
        AccountName: [
          { required: true, message: "请填写用户名", trigger: "blur" }
        ],
        ComanyName: [
          { required: true, message: "请填写公司名称", trigger: "blur" }
        ],
        LinkName: [
          { required: true, message: "请填写客户联系人", trigger: "blur" }
        ],
        LinkPhone: [
          {
            required: true,
            pattern: /^1[34578]\d{9}$/, //可以写正则表达式呦呦呦
            message: "目前只支持中国大陆的手机号码",
            trigger: "blur"
          }
        ],
        IsLoseTicket: [
          { required: true, message: "请选择发票是否遗失", trigger: "change" }
        ],
        RefundMoney: [
          { required: true, message: "请填写退款金额", trigger: "blur" }
        ],
        RefundBecause: [
          { required: true, message: "请选择退款原因", trigger: "change" }
        ],
        RefundBecauseOf: [
          { required: true, message: "请填写退款原因详情", trigger: "blur" }
        ],
        MainName: [
          { required: true, message: "请填写核查申请部门", trigger: "blur" }
        ],
        TrueName: [
          { required: true, message: "请填写核查申请人", trigger: "blur" }
        ],
        Product: [
          { required: true, message: "请选择退款产品", trigger: "change" }
        ],
        IsDeposit: [
          {
            required: true,
            message: "请选择预存款是否消费完毕",
            trigger: "change"
          }
        ]
      },
      c_rules: {
        AccountName: [
          { required: true, message: "请填写用户名", trigger: "blur" }
        ],
        ComanyName: [
          { required: true, message: "请填写公司名称", trigger: "blur" }
        ],
        LinkName: [
          { required: true, message: "请填写客户联系人", trigger: "blur" }
        ],
        LinkPhone: [
          {
            required: true,
            pattern: /^1[34578]\d{9}$/, //可以写正则表达式呦呦呦
            message: "目前只支持中国大陆的手机号码",
            trigger: "blur"
          }
        ],
        IsLoseTicket: [
          { required: true, message: "请选择发票是否遗失", trigger: "change" }
        ],
        RefundMoney: [
          { required: true, message: "请填写退款金额", trigger: "blur" }
        ],
        RefundBecause: [
          { required: true, message: "请选择退款原因", trigger: "change" }
        ],
        RefundBecauseOf: [
          { required: true, message: "请填写退款原因详情", trigger: "blur" }
        ],
        MainName: [
          { required: true, message: "请填写核查申请部门", trigger: "blur" }
        ],
        TrueName: [
          { required: true, message: "请填写核查申请人", trigger: "blur" }
        ],
        Product: [
          { required: true, message: "请选择退款产品", trigger: "change" }
        ],
        IsDeposit: [
          {
            required: true,
            message: "请选择预存款是否消费完毕",
            trigger: "change"
          }
        ]
      },
      d_rules: {
        AccountName: [
          { required: true, message: "请填写用户名", trigger: "blur" }
        ],
        ComanyName: [
          { required: true, message: "请填写公司名称", trigger: "blur" }
        ],
        LinkName: [
          { required: true, message: "请填写客户联系人", trigger: "blur" }
        ],
        LinkPhone: [
          {
            required: true,
            pattern: /^1[34578]\d{9}$/, //可以写正则表达式呦呦呦
            message: "目前只支持中国大陆的手机号码",
            trigger: "blur"
          }
        ],
        IsLoseTicket: [
          { required: true, message: "请选择发票是否遗失", trigger: "change" }
        ],
        RefundMoney: [
          { required: true, message: "请填写退款金额", trigger: "blur" }
        ],
        RefundBecause: [
          { required: true, message: "请选择退款原因", trigger: "change" }
        ],
        RefundBecauseOf: [
          { required: true, message: "请填写退款原因详情", trigger: "blur" }
        ],
        MainName: [
          { required: true, message: "请填写核查申请部门", trigger: "blur" }
        ],
        TrueName: [
          { required: true, message: "请填写核查申请人", trigger: "blur" }
        ],
        Product: [
          { required: true, message: "请选择退款产品", trigger: "change" }
        ],
        IsDeposit: [
          {
            required: true,
            message: "请选择预存款是否消费完毕",
            trigger: "change"
          }
        ]
      },
      fileList: [],
      aDisabled : false,
    };
  },
  methods: {
    /**
     * tab切换事件
     */
    handleTabClick(tab) {
      this.tabIndex = tab.index;
			this.becauseArray = [];
			this.b_sellDeductionFlag = false;
			this.b_serviceDeductionFlag = false;
			this.b_sellDeduction = '';
			this.b_serviceDeduction = '';
			this.c_sellDeductionFlag = false;
			this.c_serviceDeductionFlag = false;
			this.c_sellDeduction = '';
			this.c_serviceDeduction = '';
    },
    /**
     * 下载模板
     */ 
    download_doc(file_name) {
      if (file_name == "RefundConfirmation") {
        window.open(
          "http://tuikuan.text.ruizhiqi.com/download/【模板】退款确认书（郑州）.docx"
        );
      } else if (file_name == "Qualifications") {
        window.open(
          "http://tuikuan.text.ruizhiqi.com/download/【模板】退款确认书（郑州）.docx"
        );
      }
    },
    /**
     * 提交表单
     */
    async a_form_submitForm(form) {
      this.$refs["a_form.Informations"].validate(async valid => {
        if (valid) {
          this.a_form.Informations.RefundTypes = this.tabIndex;
          this.a_form.Informations.Id = "";
          this.a_form.Informations.MainId = "123";
          this.a_form.Informations.UserCode = "60563";
          await InformationsAdd(this.a_form.Informations).then(res => {
            this.a_form.Material.InfomationId = res.Msg;
            MaterialAdd(this.a_form.Material).then(res => {
              // 获取发送时的下面步骤集合
              GetFlowSendNextSteps(
                this.userInfo.userid,
                "ee796122-1337-4b0e-8c0c-22d8d1dd7e70",
                this.a_form.Material.InfomationId
              ).then(res => {
                var val = "";
                if (this.tabIndex == 0) {
                  val = "未消费";
                } else if (this.tabIndex == 1) {
                  val = "已消费退现";
                } else if (this.tabIndex == 2) {
                  val = "已消费转账户";
                } else if (this.tabIndex == 3) {
                  val = "保证金";
                }
                var paras = {
                  flowid: "44cae30c-23a0-4f36-aa34-914350682380",
                  //当前用户id
                  senderid: this.userInfo.userid,
                  data: [
                    {
                      field: "Types",
                      //根据tab来改变
                      value: val
                    }
                  ],
                  instanceid: this.a_form.Material.InfomationId,
                  step: [
                    {
                      id: res[0].Step.ID,
                      member: res[0].DefaultMemberID
                    }
                  ],
                  type: "submit",
                  isfirststep: true,
                  taskid: "",
                  stepid: res[0].DefaultMemberID,
                  comment: this.a_form.Informations.ComanyName,
                  groupid: this.userInfo.groupid,
                  title: this.userInfo.TrueName + "的退款申请",
                  ccid: "",
                  ccname: "",
                  sendername: this.userInfo.TrueName
                };
                Excuteflow(paras).then(res => {
                  //最后跳转路由
                  this.$message({
                    message: "发起审批成功",
                    type: "success"
                  });
                  this.$router.push("/Refund/myRefundList");
                });
              });
            });
          });
        } else {
          this.$message.error("表单提交失败！");
          return false;
        }
      });
    },
    async b_form_submitForm(form) {
      this.$refs["b_form.Informations"].validate(async valid => {
        if (valid) {
          this.b_form.Informations.RefundTypes = this.tabIndex;
          this.b_form.Informations.Id = "";
          this.b_form.Informations.MainId = "123";
          this.b_form.Informations.UserCode = "60563";
          await InformationsAdd(this.b_form.Informations).then(res => {
            this.b_form.Material.InfomationId = res.Msg;
            MaterialAdd(this.b_form.Material).then(res => {
              // 获取发送时的下面步骤集合
              GetFlowSendNextSteps(
                this.userInfo.userid,
                "ee796122-1337-4b0e-8c0c-22d8d1dd7e70",
                this.b_form.Material.InfomationId
              ).then(res => {
                var val = "";
                if (this.tabIndex == 0) {
                  val = "未消费";
                } else if (this.tabIndex == 1) {
                  val = "已消费退现";
                } else if (this.tabIndex == 2) {
                  val = "已消费转账户";
                } else if (this.tabIndex == 3) {
                  val = "保证金";
                }
                var paras = {
                  flowid: "44cae30c-23a0-4f36-aa34-914350682380",
                  //当前用户id
                  senderid: this.userInfo.userid,
                  data: [
                    {
                      field: "Types",
                      //根据tab来改变
                      value: val
                    }
                  ],
                  instanceid: this.b_form.Material.InfomationId,
                  step: [
                    {
                      id: res[0].Step.ID,
                      member: res[0].DefaultMemberID
                    }
                  ],
                  type: "submit",
                  isfirststep: true,
                  taskid: "",
                  stepid: res[0].DefaultMemberID,
                  comment: this.b_form.Informations.ComanyName,
                  groupid: this.userInfo.groupid,
                  title: this.userInfo.TrueName + "的退款申请",
                  ccid: "",
                  ccname: "",
                  sendername: this.userInfo.TrueName
                };
                Excuteflow(paras).then(res => {
                  //最后跳转路由
                  this.$message({
                    message: "发起审批成功",
                    type: "success"
                  });
                  this.$router.push("/Refund/myRefundList");
                });
              });
            });
          });
        } else {
          this.$message.error("表单提交失败！");
          return false;
        }
      });
    },
    async c_form_submitForm(form) {
      this.$refs["c_form.Informations"].validate(async valid => {
        if (valid) {
          this.c_form.Informations.RefundTypes = this.tabIndex;
          this.c_form.Informations.Id = "";
          this.c_form.Informations.MainId = "123";
          this.c_form.Informations.UserCode = "60563";
          await InformationsAdd(this.c_form.Informations).then(res => {
            this.c_form.Material.InfomationId = res.Msg;
            MaterialAdd(this.c_form.Material).then(res => {
              // 获取发送时的下面步骤集合
              GetFlowSendNextSteps(
                this.userInfo.userid,
                "ee796122-1337-4b0e-8c0c-22d8d1dd7e70",
                this.c_form.Material.InfomationId
              ).then(res => {
                var val = "";
                if (this.tabIndex == 0) {
                  val = "未消费";
                } else if (this.tabIndex == 1) {
                  val = "已消费退现";
                } else if (this.tabIndex == 2) {
                  val = "已消费转账户";
                } else if (this.tabIndex == 3) {
                  val = "保证金";
                }
                var paras = {
                  flowid: "44cae30c-23a0-4f36-aa34-914350682380",
                  //当前用户id
                  senderid: this.userInfo.userid,
                  data: [
                    {
                      field: "Types",
                      //根据tab来改变
                      value: val
                    }
                  ],
                  instanceid: this.c_form.Material.InfomationId,
                  step: [
                    {
                      id: res[0].Step.ID,
                      member: res[0].DefaultMemberID
                    }
                  ],
                  type: "submit",
                  isfirststep: true,
                  taskid: "",
                  stepid: res[0].DefaultMemberID,
                  comment: this.c_form.Informations.ComanyName,
                  groupid: this.userInfo.groupid,
                  title: this.userInfo.TrueName + "的退款申请",
                  ccid: "",
                  ccname: "",
                  sendername: this.userInfo.TrueName
                };
                Excuteflow(paras).then(res => {
                  //最后跳转路由
                  this.$message({
                    message: "发起审批成功",
                    type: "success"
                  });
                  this.$router.push("/Refund/myRefundList");
                });
              });
            });
          });
        } else {
          this.$message.error("表单提交失败！");
          return false;
        }
      });
    },
    async d_form_submitForm(form) {
      this.$refs["d_form.Informations"].validate(async valid => {
        if (valid) {
          this.d_form.Informations.RefundTypes = this.tabIndex;
          this.d_form.Informations.Id = "";
          this.d_form.Informations.MainId = "123";
          this.d_form.Informations.UserCode = "60563";
          await InformationsAdd(this.d_form.Informations).then(res => {
            this.d_form.Material.InfomationId = res.Msg;
            MaterialAdd(this.d_form.Material).then(res => {
              // 获取发送时的下面步骤集合
              GetFlowSendNextSteps(
                this.userInfo.userid,
                "ee796122-1337-4b0e-8c0c-22d8d1dd7e70",
                this.d_form.Material.InfomationId
              ).then(res => {
                var val = "";
                if (this.tabIndex == 0) {
                  val = "未消费";
                } else if (this.tabIndex == 1) {
                  val = "已消费退现";
                } else if (this.tabIndex == 2) {
                  val = "已消费转账户";
                } else if (this.tabIndex == 3) {
                  val = "保证金";
                }
                var paras = {
                  flowid: "44cae30c-23a0-4f36-aa34-914350682380",
                  //当前用户id
                  senderid: this.userInfo.userid,
                  data: [
                    {
                      field: "Types",
                      //根据tab来改变
                      value: val
                    }
                  ],
                  instanceid: this.d_form.Material.InfomationId,
                  step: [
                    {
                      id: res[0].Step.ID,
                      member: res[0].DefaultMemberID
                    }
                  ],
                  type: "submit",
                  isfirststep: true,
                  taskid: "",
                  stepid: res[0].DefaultMemberID,
                  comment: this.d_form.Informations.ComanyName,
                  groupid: this.userInfo.groupid,
                  title: this.userInfo.TrueName + "的退款申请",
                  ccid: "",
                  ccname: "",
                  sendername: this.userInfo.TrueName
                };
                Excuteflow(paras).then(res => {
                  //最后跳转路由
                  this.$message({
                    message: "发起审批成功",
                    type: "success"
                  });
                  this.$router.push("/Refund/myRefundList");
                });
              });
            });
          });
        } else {
          this.$message.error("表单提交失败！");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    /**
     * 上传所需退款资料 start
     */
    // 退款确认书
    handleSuccess_RefundConfirmation(response) {
      this.a_form.Material.RefundConfirmation = response;
      this.b_form.Material.RefundConfirmation = response;
      this.d_form.Material.RefundConfirmation = response;
    },
    // 主体资质复印件
    handleSuccess_Qualifications(response) {
      this.a_form.Material.Qualifications = response;
      this.b_form.Material.Qualifications = response;
      this.d_form.Material.Qualifications = response;
    },
    // 法人身份证复印件
    handleSuccess_LegalCard(response) {
      this.a_form.Material.LegalCard = response;
      this.b_form.Material.LegalCard = response;
      this.d_form.Material.LegalCard = response;
    },
    // 委托授权书
    handleSuccess_Entrust(response) {
      this.a_form.Material.Entrust = response;
      this.b_form.Material.Entrust = response;
      this.c_form.Material.Entrust = response;
      this.d_form.Material.Entrust = response;
    },
    // 被委托人身份证复印件
    handleSuccess_EntrustCard(response) {
      this.a_form.Material.EntrustCard = response;
      this.b_form.Material.EntrustCard = response;
      this.c_form.Material.EntrustCard = response;
      this.d_form.Material.EntrustCard = response;
    },
    // 发票
    handleSuccess_Ticket(response) {
      this.a_form.Material.Ticket = response;
    },
    // 合同
    handleSuccess_Agreement(response) {
      this.a_form.Material.Agreement = response;
    },
    // 收据
    handleSuccess_Receipt(response) {
      this.a_form.Material.Receipt = response;
    },
    // 发票遗失说明
    handleSuccess_TicketLose(response) {
      this.b_form.Material.TicketLose = response;
      this.c_form.Material.TicketLose = response;
    },
    // 转账确认书
    handleSuccess_Transfers(response) {
      this.c_form.Material.Transfers = response;
    },
    // 客户资质
    handleSuccess_Customer(response) {
      this.c_form.Material.Customer = response;
    },
    // 两个账户后台截图
    handleSuccess_AccountPic(response) {
      this.c_form.Material.AccountPic = response;
    },
    // 两个账户营业执照复印件
    handleSuccess_License(response) {
      this.c_form.Material.License = response;
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    /**
     * 上传所需退款资料 end
     */
		
    /**
     * 公司名称失焦触发
     */
    async blurComanyNameAForm(){
      var Refund = await GetRefund(this.a_form.Informations.ComanyName);
      var IsOpen = await GetIsOpen(this.a_form.Informations.ComanyName);
      if(Refund == 'success'){
        // 未消费退款时 如果已消费,弹出提示框提示,并将表单提交按钮置为灰色无法选中
        this.$message.error('该公司已消费,无法申请退款');
        this.aDisabled = true;
      }else if(Refund == 'fail'){
        this.$message({
          message: '该公司未消费,可以申请退款',
          type: 'success'
        });
        this.aDisabled = false;
      }
      if(IsOpen == 'success'){
        this.a_form.Informations.IsOpen = '1';
      }else if(IsOpen == 'fail'){
        this.a_form.Informations.IsOpen = '0';
      }
    },
    /**
     * B表单 用户名失焦触发
     */
    async blurAccountNameBForm(){
      var BalanceMoney = await GetBalanceMoney(this.b_form.Informations.AccountName,this.b_form.Informations.Product);
      var IsOk = await GetIsOk(this.b_form.Informations.AccountName,this.b_form.Informations.Product);
      if( IsOk == 'success' ){
        // 未消费完 0
        this.b_form.Informations.IsDeposit = '0'
      }else if( IsOk == 'fail' ){
        // 已消费完 1
        this.b_form.Informations.IsDeposit = '1'
      }
      if( BalanceMoney.result== 'fail'){
        this.$message.error('"该账户不存在"');
      }else if(BalanceMoney.result== 'success')
      this.b_form.Informations.ConsumeMoney = BalanceMoney.Msg;
    },
    /**
     * C表单 用户名失焦触发
     */
    async blurAccountNameCForm(){
      var BalanceMoney = await GetBalanceMoney(this.c_form.Informations.AccountName,this.c_form.Informations.Product);
      var IsOk = await GetIsOk(this.c_form.Informations.AccountName,this.c_form.Informations.Product);
      if( IsOk == 'success' ){
        // 未消费完 0
        this.c_form.Informations.IsDeposit = '0'
      }else if( IsOk == 'fail' ){
        // 已消费完 1
        this.c_form.Informations.IsDeposit = '1'
      }
      if( BalanceMoney.result== 'fail'){
        this.$message.error('"该账户不存在"');
      }else if(BalanceMoney.result== 'success')
      this.c_form.Informations.ConsumeMoney = BalanceMoney.Msg;
    },
    /**
     * D表单 用户名失焦触发
     */
    async blurAccountNameDForm(){
      var BalanceMoney = await GetBalanceMoney(this.d_form.Informations.AccountName,this.d_form.Informations.Product);
      var IsOk = await GetIsOk(this.d_form.Informations.AccountName,this.d_form.Informations.Product);
      if( IsOk == 'success' ){
        // 未消费完 0
        this.d_form.Informations.IsDeposit = '0'
      }else if( IsOk == 'fail' ){
        // 已消费完 1
        this.d_form.Informations.IsDeposit = '1'
      }
      if( BalanceMoney.result== 'fail'){
        this.$message.error('"该账户不存在"');
      }else if(BalanceMoney.result== 'success')
      this.d_form.Informations.ConsumeMoney = BalanceMoney.Msg;
    },
    changeSelectB(){
      this.blurAccountNameBForm()
    },
    changeSelectC(){
      this.blurAccountNameCForm()
    },
    changeSelectD(){
      this.blurAccountNameDForm()
    },
		//监听表单a选择退款原因
		handleBeacuseOfAChange(value) {
			this.a_form.Informations.RefundBecause = value[0];
			if(value[0] !== '其他原因'){
				this.RefundBecauseOf_flag_a = false;
				this.a_form.Informations.RefundBecauseOf = value[1];
			}else{
        this.a_form.Informations.RefundBecauseOf = '';
				this.RefundBecauseOf_flag_a = true;
			}
		},
		//监听表单b选择退款原因
		handleBeacuseOfBChange(value) {
			this.b_form.Informations.RefundBecause = value[0];
			if(value[0] !== '其他原因'){
				this.RefundBecauseOf_flag_b = false;
				this.b_form.Informations.RefundBecauseOf = value[1];
			}else{
        this.b_form.Informations.RefundBecauseOf = '';
				this.RefundBecauseOf_flag_b = true;
			}
		},
		//监听表单c选择退款原因
		handleBeacuseOfCChange(value) {
			this.c_form.Informations.RefundBecause = value[0];
			if(value[0] !== '其他原因'){
				this.RefundBecauseOf_flag_c = false;
				this.c_form.Informations.RefundBecauseOf = value[1];
			}else{
        this.c_form.Informations.RefundBecauseOf = '';
				this.RefundBecauseOf_flag_c = true;
			}
		},
		//监听表单a选择退款原因
		handleBeacuseOfDChange(value) {
			this.d_form.Informations.RefundBecause = value[0];
			if(value[0] !== '其他原因'){
				this.RefundBecauseOf_flag_d = false;
				this.d_form.Informations.RefundBecauseOf = value[1];
			}else{
        this.d_form.Informations.RefundBecauseOf = '';
				this.RefundBecauseOf_flag_d = true;
			}
		},
		// 已消费退现扣减
		async b_blur_deduction(){
			var res = await Getkoujian(this.b_form.Informations.AccountName,0,this.b_form.Informations.RefundMoney)
			if(res.result == "success"){
				this.b_sellDeductionFlag = true;
				this.b_serviceDeductionFlag = true;
				this.b_sellDeduction = res.XSMsg;
				this.b_serviceDeduction = res.KFMsg;
			}
		},
		// 已消费转账户扣减
		async c_blur_deduction(){
			var res = await Getkoujian(this.c_form.Informations.AccountName,1,this.c_form.Informations.RefundMoney)
			if(res.result == "success"){
				this.c_sellDeductionFlag = true;
				this.c_serviceDeductionFlag = true;
				this.c_sellDeduction = res.XSMsg;
				this.c_serviceDeduction = res.KFMsg;
			}
		},
  },
  created() {
    var userinfo = JSON.parse(cryptoDecode(window.sessionStorage.getItem('userinfo')));
    this.userInfo.TrueName = userinfo.TrueName
    this.userInfo.userid = userinfo.UserId;
    this.userInfo.MainName = userinfo.FrameName;
    this.userInfo.groupid = userinfo.FrameId;
    this.a_form.Informations.TrueName = this.userInfo.TrueName;
    this.a_form.Informations.MainName = this.userInfo.MainName;
    this.b_form.Informations.TrueName = this.userInfo.TrueName;
    this.b_form.Informations.MainName = this.userInfo.MainName;
    this.c_form.Informations.TrueName = this.userInfo.TrueName;
    this.c_form.Informations.MainName = this.userInfo.MainName;
    this.d_form.Informations.TrueName = this.userInfo.TrueName;
    this.d_form.Informations.MainName = this.userInfo.MainName;
  }
};
</script>
<style lang="less" scoped>
.box-card {
  margin-top: 20px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

//下拉菜单
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

//content_area
.content_box {
  margin-top: 15px;
  .feund_form {
    height: 600px;
    width: 100%;
    .title_1 {
      text-align: left;
      height: 44xp;
      line-height: 44px;
      margin-bottom: 20px;
      font-weight: 500;
    }
  }
}
.el-upload__tip {
  float: right;
  margin-left: 16px;
  transform: translateY(-6px);
}
</style>
